var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Spaces.tsx
import { createContext as createContext2, useContext as useContext2, useReducer as useReducer2, useEffect as useEffect2 } from "react";
import { useQueries } from "@tanstack/react-query";

// src/lib/spaces-data.tsx
import { avWebQLApi } from "@availity/api-axios";
var actions = {
  SPACES: (currentState, { spaces, spacesByConfig, spacesByPayer }) => ({
    previousSpacesMap: spaces,
    previousSpacesByConfigMap: spacesByConfig,
    previousSpacesByPayerMap: spacesByPayer,
    error: void 0,
    loading: false
  }),
  ERROR: (state, { error }) => __spreadProps(__spreadValues({}, state), {
    loading: false,
    error
  }),
  LOADING: (state, { loading }) => __spreadProps(__spreadValues({}, state), {
    loading: loading !== void 0 ? loading : !state.loading
  })
};
var spacesReducer = (state, action) => {
  const { type } = action;
  return actions[type](state, action);
};
var fetchSpaces = (_0) => __async(void 0, [_0], function* ({ query, clientId, variables }) {
  const headers = {};
  if (clientId) {
    headers["X-Client-ID"] = clientId;
  }
  const {
    data: {
      data: { configurationPagination }
    }
  } = yield avWebQLApi.create(
    {
      query,
      variables: __spreadValues({}, variables)
    },
    { headers: __spreadValues({}, headers) }
  );
  const {
    pageInfo: { currentPage, hasNextPage },
    items
  } = configurationPagination;
  return {
    items,
    currentPage,
    hasNextPage
  };
});
var fetchAllSpaces = (_0) => __async(void 0, [_0], function* ({
  query,
  clientId,
  variables,
  _spaces = []
}) {
  const { items, currentPage, hasNextPage } = yield fetchSpaces({ query, clientId, variables });
  _spaces.push(...items);
  if (hasNextPage) {
    const vars = __spreadProps(__spreadValues({}, variables), {
      page: currentPage + 1
    });
    return fetchAllSpaces({ query, clientId, variables: vars, _spaces });
  }
  return _spaces;
});

// src/lib/configurationFindMany.tsx
var configurationFindMany_default = `query configurationFindMany($ids: [String!], $payerIDs: [ID!], $types: [TypeEnum!], $page: Int) {
  configurationPagination(filter: { ids: $ids, payerIds: $payerIDs, types: $types }, page: $page) {
    pageInfo {
      hasNextPage
      currentPage
    }
    items {
      ... on Configuration {
        configurationId
        name
        shortName
        type
        activeDate
        isNew
        description
        payerIDs
        parentIDs
        meta
        metadataPairs {
          name
          value
        }
      }

      ... on Node {
        id
      }

      ... on Alert {
        link {
          text
          target
          url
        }
      }

      ... on Container {
        link {
          text
          target
          url
        }
        images {
          tile
          promotional
          logo
          billboard
        }
      }

      ... on PayerSpace {
        link {
          text
          target
          url
        }
        images {
          tile
          logo
          billboard
        }
        url
      }

      ... on Application {
        link {
          text
          target
          url
        }
      }

      ... on Resource {
        link {
          text
          target
          url
        }
      }

      ... on Navigation {
        icons {
          dashboard
          navigation
        }
        images {
          promotional
        }
      }

      ... on Learning {
        images {
          promotional
        }
      }

      ... on Proxy {
        url
      }

      ... on File {
        url
      }
    }
  }
}`;

// src/lib/modals/ModalProvider.tsx
import { createContext, useContext, useReducer } from "react";
import { isAbsoluteUrl } from "@availity/resolve-url";
import { Dialog, DialogTitle, DialogActions } from "@availity/mui-dialog";
import { Button } from "@availity/mui-button";

// src/lib/helpers.tsx
import qs from "qs";
var updateUrl = (url, key, value) => {
  const [uri, queryString] = url.split("?");
  const currentParams = qs.parse(queryString);
  const additionalParams = key && value && { [key]: value };
  const newParams = qs.stringify(__spreadValues(__spreadValues({}, currentParams), additionalParams), { sort: (a, b) => a.localeCompare(b) });
  return `${uri}?${newParams}`;
};
var getUrl = (url = "", loadApp, absolute) => {
  if (absolute || !loadApp) return url;
  return `/public/apps/home/#!/loadApp?appUrl=${encodeURIComponent(url)}`;
};
var getTarget = (target) => {
  if (target && !target.startsWith("_")) {
    if (target === "BODY") {
      return "_self";
    }
    if (target === "TAB") {
      return "_blank";
    }
  }
  return target || "_self";
};
var isFunction = (children) => typeof children === "function";
var isReactNodeFunction = (children) => typeof children === "function";

// src/lib/topApps.tsx
import avMessage from "@availity/message-core";
import dayjs from "dayjs";
var TOP_APPS = {
  ALLOWED_TYPES: ["APPLICATION", "RESOURCE", "NAVIGATION"],
  DISALLOWED_TYPES: ["reporting", "how_to_guide_dental_providers", "my_account_profile", "my_administrators"],
  KEYS: {
    VALUES: "myTopApps",
    LAST_UPDATED: "top-apps-updated"
  },
  UPDATE_EVENT: "av:topApps:updated"
};
var getItemLocalStorage = (key) => {
  try {
    const value = window.localStorage.getItem(key);
    if (value === null) {
      return null;
    }
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};
var canTrackSpace = (spaceId, type) => TOP_APPS.ALLOWED_TYPES.some((t) => t === type) && !TOP_APPS.DISALLOWED_TYPES.some((id) => id === spaceId);
var getLocalStorageTopApps = (akaname) => {
  const topAppsValues = getItemLocalStorage(`${TOP_APPS.KEYS.VALUES}-${akaname}`);
  return topAppsValues;
};
var updateTopApps = (space, akaname) => __async(void 0, null, function* () {
  if (!space.configurationId || !space.type) return;
  if (canTrackSpace(space.configurationId, space.type)) {
    const today = dayjs();
    const topApps = (yield getLocalStorageTopApps(akaname)) || {};
    window.localStorage.setItem(`${TOP_APPS.KEYS.LAST_UPDATED}-${akaname}`, today.format());
    const currentCount = topApps[space.configurationId] && typeof topApps[space.configurationId].count === "number" ? topApps[space.configurationId].count : 0;
    topApps[space.configurationId] = __spreadProps(__spreadValues({}, topApps == null ? void 0 : topApps[space.configurationId]), {
      count: currentCount + 1,
      lastUse: today.format()
    });
    window.localStorage.setItem(`${TOP_APPS.KEYS.VALUES}-${akaname}`, JSON.stringify(topApps));
    avMessage.send(TOP_APPS.UPDATE_EVENT);
  }
});

// src/lib/modals/DisclaimerModal.tsx
import { useState, useEffect } from "react";
import { avWebQLApi as avWebQLApi2 } from "@availity/api-axios";
import ReactMarkdown from "react-markdown";
import { CircularProgress } from "@availity/mui-progress";
import { DialogContent } from "@availity/mui-dialog";
import { jsx } from "react/jsx-runtime";
var disclaimerQuery = `query disclaimerFindOne($id: ID!) {
  configurationFindOne(id: $id) {
    ... on Text {
      description
    }
  }
}`;
var DisclaimerModal = ({ disclaimerId }) => {
  const [disclaimer, setDisclaimer] = useState("");
  useEffect(() => {
    const fetchDisclaimer = () => __async(void 0, null, function* () {
      if (disclaimerId) {
        const result = yield avWebQLApi2.create({ query: disclaimerQuery, variables: { id: disclaimerId } });
        setDisclaimer(result.data.data.configurationFindOne.description);
      }
    });
    fetchDisclaimer();
  }, [disclaimerId]);
  return /* @__PURE__ */ jsx(DialogContent, { children: disclaimer ? /* @__PURE__ */ jsx(ReactMarkdown, { children: disclaimer }) : /* @__PURE__ */ jsx(CircularProgress, {}) });
};

// src/lib/modals/MultiPayerModal.tsx
import { DialogContent as DialogContent2 } from "@availity/mui-dialog";
import { Grid, Box } from "@availity/mui-layout";
import { Typography } from "@availity/mui-typography";

// src/lib/SpacesImage.tsx
import { CircularProgress as CircularProgress2 } from "@availity/mui-progress";
import { Img } from "react-image";
import { jsx as jsx2 } from "react/jsx-runtime";
var SpacesImage = (_a) => {
  var _b = _a, {
    spaceId,
    payerId,
    imageType = "url",
    fallback,
    Loader = CircularProgress2
  } = _b, props = __objRest(_b, [
    "spaceId",
    "payerId",
    "imageType",
    "fallback",
    "Loader"
  ]);
  var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  let spaces;
  if (spaceId) {
    spaces = useSpaces(spaceId);
  } else if (payerId) {
    spaces = useSpaces(payerId);
  }
  const { loading } = useSpacesContext();
  const id = spaceId || payerId || (spaces == null ? void 0 : spaces[0].id) || (spaces == null ? void 0 : spaces[0].configurationId);
  const imageMap = {
    "images.logo": (_b2 = (_a2 = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _a2.images) == null ? void 0 : _b2.logo,
    "images.tile": (_d = (_c = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _c.images) == null ? void 0 : _d.tile,
    "images.billboard": (_f = (_e = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _e.images) == null ? void 0 : _f.billboard,
    "images.promotional": (_h = (_g = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _g.images) == null ? void 0 : _h.promotional,
    "images.promotionalHover": (_j = (_i = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _i.images) == null ? void 0 : _j.promotionalHover,
    url: (_k = spaces == null ? void 0 : spaces[0]) == null ? void 0 : _k.url
  };
  let url = imageMap[imageType];
  if (!url && loading) {
    return /* @__PURE__ */ jsx2(Loader, { id: `app-${id}-loading` });
  }
  if (!url && !loading && fallback) {
    url = fallback;
  }
  if (!url || !id) return null;
  return /* @__PURE__ */ jsx2(
    Img,
    __spreadValues({
      id: props.id || `app-img-${id}`,
      src: url,
      alt: `Space ${imageType}`,
      loader: /* @__PURE__ */ jsx2(Loader, { id: `app-img-${id}-loading` })
    }, props)
  );
};

// src/lib/modals/MultiPayerModal.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var MultiPayerModal = ({ parentPayerSpaces, name, state: { selectedOption }, setState }) => /* @__PURE__ */ jsxs(DialogContent2, { children: [
  /* @__PURE__ */ jsx3(Typography, { children: `Open ${name} as: ${selectedOption ? selectedOption.name || selectedOption.id : ""}` }),
  /* @__PURE__ */ jsx3(Grid, { direction: "row", children: parentPayerSpaces && parentPayerSpaces.map((payerSpace) => /* @__PURE__ */ jsx3(Box, { onClick: () => setState({ selectedOption: payerSpace }), children: /* @__PURE__ */ jsx3(SpacesImage, { spaceId: payerSpace.configurationId, imageType: "images.tile" }) })) })
] });

// src/lib/modals/modal-types.tsx
var isModalOptions = (action) => action.spaceType !== void 0;
var isModalState = (action) => action.selectedOption !== void 0;

// src/lib/modals/ModalProvider.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var MODAL_INITIAL_STATE = {
  isOpen: false,
  modalOptions: void 0,
  modalState: { selectedOption: { id: "", name: "" } },
  selectedModal: {}
};
var ModalContext = createContext(null);
var useModal = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("ModalContext be used inside a Provider");
  return ctx;
};
var MODAL_TYPES = {
  DISCLAIMER: {
    body: DisclaimerModal,
    buttonProps: () => ({
      children: "Accept"
    }),
    onSubmit: ({ link, id: spaceId }) => {
      var _a;
      window.open(((_a = link.url) == null ? void 0 : _a[0]) === "/" ? updateUrl(link.url, "spaceId", spaceId) : link.url, link.target);
    }
  },
  MULTI_PAYER: {
    body: MultiPayerModal,
    buttonProps: ({ selectedOption }) => ({
      children: "Continue",
      disabled: selectedOption === void 0
    }),
    onSubmit: ({ metadata, link, id: spaceId, name }, modalState, dispatch) => {
      if (metadata == null ? void 0 : metadata.disclaimerId) {
        dispatch({ type: "OPEN_DISCLAIMER_MODAL", disclaimerId: metadata.disclaimerId, link, id: spaceId, name });
        return;
      }
      const target = getTarget(link.target);
      if (link.url) {
        window.open(
          !isAbsoluteUrl(link.url) ? getUrl(updateUrl(link.url, "spaceId", modalState.selectedOption.id), false, false) : link.url,
          target
        );
      }
    }
  }
};
var modalActions = {
  RESET: () => MODAL_INITIAL_STATE,
  OPEN_DISCLAIMER_MODAL: (state, modalOptions) => __spreadProps(__spreadValues({}, state), {
    isOpen: true,
    selectedModal: MODAL_TYPES.DISCLAIMER,
    modalOptions: __spreadProps(__spreadValues({}, modalOptions), { type: modalOptions.spaceType })
  }),
  OPEN_MULTI_PAYER_MODAL: (state, modalOptions) => __spreadProps(__spreadValues({}, state), {
    isOpen: true,
    selectedModal: MODAL_TYPES.MULTI_PAYER,
    modalOptions: __spreadProps(__spreadValues({}, modalOptions), {
      type: modalOptions.spaceType
    })
  }),
  UPDATE_MODAL_STATE: (state, modalState) => __spreadProps(__spreadValues({}, state), {
    modalState
  })
};
var modalReducer = (state, _a) => {
  var _b = _a, { type } = _b, action = __objRest(_b, ["type"]);
  if (type === "RESET") return modalActions.RESET();
  if (isModalOptions(action)) {
    if (type === "OPEN_MULTI_PAYER_MODAL") return modalActions.OPEN_MULTI_PAYER_MODAL(state, action);
    else if (type === "OPEN_DISCLAIMER_MODAL") return modalActions.OPEN_DISCLAIMER_MODAL(state, action);
  } else if (isModalState(action)) {
    if (type === "UPDATE_MODAL_STATE") return modalActions.UPDATE_MODAL_STATE(state, action);
  }
  return state;
};
var ModalProvider = ({ children }) => {
  const [{ selectedModal, modalOptions, modalState, isOpen }, dispatch] = useReducer(modalReducer, MODAL_INITIAL_STATE);
  const toggle = () => dispatch({ type: "RESET" });
  const buttonProps = (selectedModal == null ? void 0 : selectedModal.buttonProps) && (selectedModal == null ? void 0 : selectedModal.buttonProps(__spreadProps(__spreadValues({}, modalState), { modalOptions })));
  const Body = selectedModal == null ? void 0 : selectedModal.body;
  return /* @__PURE__ */ jsxs2(
    ModalContext.Provider,
    {
      value: (modalType, modalOptions2) => dispatch(__spreadValues({ type: `OPEN_${modalType}` }, modalOptions2)),
      children: [
        /* @__PURE__ */ jsxs2(Dialog, { open: isOpen, children: [
          /* @__PURE__ */ jsx4(DialogTitle, { id: "disclaimer-header", children: modalOptions == null ? void 0 : modalOptions.title }),
          Body && /* @__PURE__ */ jsx4(
            Body,
            __spreadProps(__spreadValues({}, modalOptions), {
              setState: (newState) => dispatch(__spreadValues({ type: "UPDATE_MODAL_STATE" }, newState)),
              state: modalState
            })
          ),
          /* @__PURE__ */ jsxs2(DialogActions, { children: [
            /* @__PURE__ */ jsx4(Button, { onClick: toggle, children: "Cancel" }),
            /* @__PURE__ */ jsx4(
              Button,
              __spreadProps(__spreadValues({
                color: "primary"
              }, buttonProps), {
                onClick: () => {
                  if ((selectedModal == null ? void 0 : selectedModal.onSubmit) && modalOptions && modalState) {
                    selectedModal.onSubmit(modalOptions, modalState, dispatch);
                  }
                  if (modalOptions) {
                    updateTopApps(
                      {
                        configurationId: modalOptions.id,
                        type: modalOptions.type,
                        name: modalOptions.name,
                        id: modalOptions.id
                      },
                      modalOptions.user
                    );
                  }
                  toggle();
                }
              })
            )
          ] })
        ] }),
        children
      ]
    }
  );
};

// src/lib/Spaces.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var INITIAL_STATE = {
  loading: true
};
var SpacesContext = createContext2(INITIAL_STATE);
var useSpacesContext = () => useContext2(SpacesContext);
var Spaces = ({
  query = configurationFindMany_default,
  variables = { types: ["PAYERSPACE"] },
  clientId,
  children,
  payerIds,
  spaceIds,
  spaces: spacesFromProps
}) => {
  const [{ previousSpacesMap, previousSpacesByConfigMap, previousSpacesByPayerMap, loading, error }, dispatch] = useReducer2(spacesReducer, INITIAL_STATE);
  const spacesMap = new Map(previousSpacesMap);
  const configIdsMap = new Map(previousSpacesByConfigMap);
  const payerIdsMap = new Map(previousSpacesByPayerMap);
  const spaceIdsToQuery = /* @__PURE__ */ new Set();
  const payerIdsToQuery = /* @__PURE__ */ new Set();
  if (spacesFromProps && spacesFromProps.length > 0) {
    for (const space of spacesFromProps) {
      if (space.id && !spacesMap.has(space.id)) {
        spacesMap.set(space.id, space);
      }
      if (space.configurationId && !configIdsMap.has(space.configurationId)) {
        configIdsMap.set(space.configurationId, space);
      }
      if (space.payerIDs) {
        for (const pId of space.payerIDs) {
          const currentSpacesForPayerId = payerIdsMap.get(pId);
          if (currentSpacesForPayerId) {
            payerIdsMap.set(pId, [...currentSpacesForPayerId, space]);
          } else {
            payerIdsMap.set(pId, [space]);
          }
        }
      }
    }
  }
  if (spaceIds && spaceIds.length > 0) {
    for (const id of spaceIds) {
      if (!(spacesMap.has(id) || configIdsMap.has(id))) {
        spaceIdsToQuery.add(id);
      }
    }
  }
  if (payerIds && payerIds.length > 0) {
    for (const pid of payerIds) {
      if (!payerIdsMap.has(pid)) {
        payerIdsToQuery.add(pid);
      }
    }
  }
  const spaceIdVars = __spreadProps(__spreadValues({}, variables), { ids: [...spaceIdsToQuery.keys()] });
  const payerIdVars = __spreadProps(__spreadValues({}, variables), { payerIDs: [...payerIdsToQuery.keys()] });
  const [
    { data: spacesBySpaceIds, isFetching: isLoadingBySpaceIds, isError: isErrorBySpaceIds },
    { data: spacesByPayerIds, isFetching: isLoadingByPayerIds, isError: isErrorByPayerIds }
  ] = useQueries({
    queries: [
      {
        queryKey: ["id", spaceIdVars],
        queryFn: () => fetchAllSpaces({ query, clientId, variables: spaceIdVars }),
        enabled: spaceIdsToQuery.size > 0
      },
      {
        queryKey: ["id", payerIdVars],
        queryFn: () => fetchAllSpaces({ query, clientId, variables: payerIdVars }),
        enabled: payerIdsToQuery.size > 0
      }
    ]
  });
  useEffect2(() => {
    if (isErrorByPayerIds || isErrorBySpaceIds) {
      dispatch({
        type: "ERROR",
        error: "Error fetching spaces.",
        loading: false
      });
    }
  }, [isErrorByPayerIds, isErrorBySpaceIds]);
  useEffect2(() => {
    dispatch({
      type: "LOADING",
      loading: true
    });
    if (spaceIdsToQuery.size === 0 && payerIdsToQuery.size === 0) {
      dispatch({
        type: "LOADING",
        loading: false
      });
      return;
    }
    if (spacesBySpaceIds) {
      for (const space of spacesBySpaceIds) {
        if (!spacesMap.has(space.id)) {
          spacesMap.set(space.id, space);
        }
        if (!configIdsMap.has(space.configurationId)) {
          configIdsMap.set(space.configurationId, space);
        }
        if (space.payerIDs) {
          for (const pId of space.payerIDs) {
            const currentSpacesForPayerId = payerIdsMap.get(pId);
            if (currentSpacesForPayerId) {
              payerIdsMap.set(pId, [...currentSpacesForPayerId, space]);
            } else {
              payerIdsMap.set(pId, [space]);
            }
          }
        }
      }
    }
    if (payerIdsToQuery.size > 0) {
      if (spacesByPayerIds) {
        for (const space of spacesByPayerIds) {
          if (!spacesMap.has(space.id)) {
            spacesMap.set(space.id, space);
          }
          if (!configIdsMap.has(space.configurationId)) {
            configIdsMap.set(space.configurationId, space);
          }
          if (space.payerIDs) {
            for (const pId of space.payerIDs) {
              const currentSpacesForPayerId = payerIdsMap.get(pId);
              if (currentSpacesForPayerId) {
                payerIdsMap.set(pId, [...currentSpacesForPayerId, space]);
              } else {
                payerIdsMap.set(pId, [space]);
              }
            }
          }
        }
      }
    }
    dispatch({
      type: "SPACES",
      spaces: spacesMap,
      spacesByConfig: configIdsMap,
      spacesByPayer: payerIdsMap,
      loading: false
    });
  }, [spacesBySpaceIds, spacesByPayerIds, payerIds, spaceIds]);
  const spacesChildren = () => {
    if (children) {
      return isReactNodeFunction(children) ? (() => children({ spaces: [spacesMap.values()], loading, error }))() : children;
    }
  };
  return /* @__PURE__ */ jsx5(
    SpacesContext.Provider,
    {
      value: {
        spaces: spacesMap,
        spacesByConfig: configIdsMap,
        spacesByPayer: payerIdsMap,
        loading: loading || isLoadingByPayerIds || isLoadingBySpaceIds,
        error
      },
      children: /* @__PURE__ */ jsx5(ModalProvider, { children: spacesChildren() })
    }
  );
};
var useSpaces = (...ids) => {
  const { spaces, spacesByConfig, spacesByPayer } = useSpacesContext();
  const idsIsEmpty = !ids || ids.length === 0;
  const callerIsExpectingFirstSpace = (ids == null ? void 0 : ids.length) === 1 && ids[0] === void 0;
  const shouldReturnAllSpaces = idsIsEmpty || callerIsExpectingFirstSpace;
  if (shouldReturnAllSpaces) {
    console.warn(`You did not pass in an ID to find a space, returning all spaces.`);
    return spaces && [...spaces.values()];
  }
  return ids.reduce((acc, id) => {
    const matchedSpace = (spaces == null ? void 0 : spaces.get(id)) || (spacesByConfig == null ? void 0 : spacesByConfig.get(id));
    if (matchedSpace) {
      acc.push(matchedSpace);
      return acc;
    }
    const matchedSpacesByPayer = spacesByPayer == null ? void 0 : spacesByPayer.get(id);
    if (matchedSpacesByPayer) {
      acc.push(...matchedSpacesByPayer);
      return acc;
    }
  }, []);
};

// src/lib/SpacesLink/SpacesLink.tsx
import dayjs2 from "dayjs";
import { Card, CardContent } from "@availity/mui-card";
import { Typography as Typography2 } from "@availity/mui-typography";
import { useMemo, cloneElement } from "react";
import { StatusChip } from "@availity/mui-chip";
import { CircularProgress as CircularProgress3 } from "@availity/mui-progress";
import Link from "@mui/material/Link";
import { FavoriteHeart } from "@availity/mui-favorites";
import { Grid as Grid2, Box as Box2 } from "@availity/mui-layout";
import { ListItem, ListItemText } from "@availity/mui-list";
import ReactMarkdown2 from "react-markdown";
import { styled } from "@mui/material/styles";

// src/lib/SpacesLink/useLink.tsx
import { useCurrentUser } from "@availity/hooks";

// src/lib/SpacesLink/linkHandlers.tsx
import nativeForm from "@availity/native-form";
import { isAbsoluteUrl as isAbsoluteUrl2 } from "@availity/resolve-url";
var openLink = (space, params) => __async(void 0, null, function* () {
  var _a, _b, _c;
  if (!((_a = space == null ? void 0 : space.link) == null ? void 0 : _a.url)) {
    return;
  }
  if (params == null ? void 0 : params.akaname) yield updateTopApps(space, params.akaname);
  const spaceId = (params == null ? void 0 : params.payerSpaceId) || ((_c = (_b = space.parents) == null ? void 0 : _b[0]) == null ? void 0 : _c.id);
  const needsSpaceId = !isAbsoluteUrl2(space.link.url) || /(test|qa(p?)-)?essentials\.availity\.com/.test(space.link.url);
  const urlWithParams = needsSpaceId ? updateUrl(space.link.url, "spaceId", spaceId) : space.link.url;
  const url = !isAbsoluteUrl2(space.link.url) ? getUrl(urlWithParams, false, false) : urlWithParams;
  const target = getTarget(space.link.target);
  window.open(url, target);
});
var openLinkWithSso = (_0, _1) => __async(void 0, [_0, _1], function* (space, { akaname, clientId, payerSpaceId, ssoParams }) {
  var _a;
  if (space.meta && space.meta.ssoId) {
    const options = ((_a = space.link) == null ? void 0 : _a.target) ? { target: getTarget(space.link.target) } : void 0;
    const attributes = __spreadValues({
      X_XSRF_TOKEN: document.cookie.replace(/(?:(?:^|.*;\s*)XSRF-TOKEN\s*=\s*([^;]*).*$)|^.*$/, "$1"),
      spaceId: payerSpaceId
    }, ssoParams);
    if (clientId) {
      attributes.X_Client_ID = clientId;
    }
    try {
      if (akaname) yield updateTopApps(space, akaname);
      yield nativeForm(space.meta.ssoId, attributes, options, space.type);
    } catch (e) {
      console.warn("Something went wrong");
    }
    return false;
  }
  return false;
});

// src/lib/SpacesLink/useLink.tsx
var isSsoSpace = (space) => (space == null ? void 0 : space.type) === "saml" || (space == null ? void 0 : space.type) === "openid";
var useLink = (spaceOrSpaceId, options) => {
  var _a, _b, _c, _d;
  const spaceFromSpacesProvider = useSpaces(
    (typeof spaceOrSpaceId === "string" ? spaceOrSpaceId : spaceOrSpaceId == null ? void 0 : spaceOrSpaceId.id) || ""
  );
  const { data: user } = useCurrentUser();
  const openModal = useModal();
  const space = (spaceFromSpacesProvider == null ? void 0 : spaceFromSpacesProvider[0]) || (typeof spaceOrSpaceId === "object" ? spaceOrSpaceId : void 0);
  const parentPayerSpaces = (_a = space == null ? void 0 : space.parents) == null ? void 0 : _a.filter(
    (p) => p.type && (p.type.toLowerCase() === "space" || p.type.toLowerCase() === "payerspace")
  );
  const legacySso = () => {
    var _a2;
    if (space && ((_a2 = space.meta) == null ? void 0 : _a2.disclaimerId) && space.link) {
      openModal("DISCLAIMER_MODAL", {
        disclaimerId: space.meta.disclaimerId,
        name: space.name,
        spaceType: space.type,
        id: space.configurationId,
        title: space.name,
        description: space.description,
        link: space.link,
        user: user == null ? void 0 : user.akaname
      });
    }
  };
  const openMultiPayerModal = () => {
    if (space && space.link)
      openModal("MULTI_PAYER_MODAL", {
        title: "Open Link as Payer",
        name: space == null ? void 0 : space.name,
        parentPayerSpaces,
        link: space == null ? void 0 : space.link,
        id: space == null ? void 0 : space.configurationId,
        spaceType: space == null ? void 0 : space.type,
        metadata: space == null ? void 0 : space.meta,
        user: user == null ? void 0 : user.akaname
      });
  };
  const mediaProps = {
    role: "link"
  };
  if (isSsoSpace(space) && ((_b = space == null ? void 0 : space.meta) == null ? void 0 : _b.ssoId)) {
    if (!(options == null ? void 0 : options.clientId)) {
      throw new Error("clientId is required for SSO spaces");
    }
    if (!options.linkAttributes) {
      throw new Error("linkAttributes are required for SSO spaces");
    }
    mediaProps.onClick = (event) => {
      event.preventDefault();
      if (options.clientId && options.linkAttributes) {
        openLinkWithSso(space, {
          akaname: user == null ? void 0 : user.akaname,
          clientId: options.clientId,
          payerSpaceId: options.linkAttributes.spaceId,
          ssoParams: options.linkAttributes
        });
      }
    };
    mediaProps.onKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (options.clientId && options.linkAttributes) {
          openLinkWithSso(space, {
            akaname: user == null ? void 0 : user.akaname,
            clientId: options.clientId,
            payerSpaceId: options.linkAttributes.spaceId,
            ssoParams: options.linkAttributes
          });
        }
      }
    };
  } else if ((_c = space == null ? void 0 : space.meta) == null ? void 0 : _c.disclaimerId) {
    mediaProps.onClick = legacySso;
    mediaProps.onKeyDown = (event) => {
      if (event.key === "Enter") return legacySso();
    };
  } else if (parentPayerSpaces && parentPayerSpaces.length > 1 && !((_d = options == null ? void 0 : options.linkAttributes) == null ? void 0 : _d.spaceId)) {
    mediaProps.onClick = openMultiPayerModal;
    mediaProps.onKeyDown = (event) => {
      if (event.key === "Enter") return openMultiPayerModal();
    };
  } else {
    mediaProps.onClick = () => {
      var _a2;
      if (space) return openLink(space, { akaname: user == null ? void 0 : user.akaname, payerSpaceId: (_a2 = options == null ? void 0 : options.linkAttributes) == null ? void 0 : _a2.spaceId });
    };
    mediaProps.onKeyDown = (event) => {
      var _a2;
      if (event.key === "Enter" && space)
        return openLink(space, { akaname: user == null ? void 0 : user.akaname, payerSpaceId: (_a2 = options == null ? void 0 : options.linkAttributes) == null ? void 0 : _a2.spaceId });
    };
  }
  return [space, mediaProps];
};

// src/lib/SpacesLink/SpacesLink.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var SpacesLinkContainer = styled(Box2, { name: "AvSpacesLink", slot: "root" })({});
var DateInfo = styled(Grid2, { name: "AvSpacesLink", slot: "AvDateInfo" })({});
var SpacesLinkFavoriteHeart = styled(Grid2, { name: "AvSpacesLink", slot: "AvFavoriteHeart" })({});
var IconLink = styled(Link, { name: "AvSpacesLink", slot: "IconLink" })({});
var getDisplayDate = (date) => dayjs2(date).format("MM/DD/YYYY");
var getContainerTag = (propTag, variant) => {
  if (variant && variant !== "default") return { card: Card, list: ListItem }[variant];
  return propTag || "div";
};
var getBodyTag = (propTag, variant) => {
  if (variant && variant !== "default") return { card: CardContent, list: "div" }[variant];
  return propTag || "div";
};
var getTitleTag = (propTag, variant) => {
  if (variant && variant !== "default") return Link;
  return propTag || Link;
};
var getTextTag = (propTag, variant) => {
  if (variant && variant !== "default") return { card: Typography2, list: ListItemText }[variant];
  return propTag || "div";
};
var SpacesLink = (_a) => {
  var _b = _a, {
    spaceId,
    space: propSpace,
    className,
    children,
    favorite,
    icon: FileIcon,
    showName = true,
    showNew,
    showDate,
    stacked,
    body = true,
    description: showDescription,
    tag,
    bodyTag,
    titleTag,
    textTag,
    titleClassName,
    variant = "default",
    loading: propsLoading,
    clientId: propsClientId,
    maxDescriptionWidth,
    style,
    linkAttributes,
    role,
    analytics,
    customBadgeText,
    customBadgeColor,
    idPrefix = ""
  } = _b, rest = __objRest(_b, [
    "spaceId",
    "space",
    "className",
    "children",
    "favorite",
    "icon",
    "showName",
    "showNew",
    "showDate",
    "stacked",
    "body",
    "description",
    "tag",
    "bodyTag",
    "titleTag",
    "textTag",
    "titleClassName",
    "variant",
    "loading",
    "clientId",
    "maxDescriptionWidth",
    "style",
    "linkAttributes",
    "role",
    "analytics",
    "customBadgeText",
    "customBadgeColor",
    "idPrefix"
  ]);
  var _a2, _b2;
  const { loading } = useSpacesContext();
  const isLoading = loading || propsLoading;
  const [linkSpace, props] = useLink(propSpace || spaceId, { clientId: propsClientId, linkAttributes });
  const showUrl = !(linkSpace == null ? void 0 : linkSpace.isGhosted) && ((_a2 = linkSpace == null ? void 0 : linkSpace.link) == null ? void 0 : _a2.url);
  const favoriteIcon = useMemo(
    () => (linkSpace == null ? void 0 : linkSpace.configurationId) && favorite && /* @__PURE__ */ jsx6(SpacesLinkFavoriteHeart, { children: /* @__PURE__ */ jsx6(
      FavoriteHeart,
      {
        id: `${idPrefix}${linkSpace == null ? void 0 : linkSpace.configurationId}`,
        name: linkSpace == null ? void 0 : linkSpace.name,
        onChange: (_, e) => e.stopPropagation()
      }
    ) }),
    [favorite, linkSpace == null ? void 0 : linkSpace.configurationId, linkSpace == null ? void 0 : linkSpace.name, idPrefix]
  );
  const dateInfo = useMemo(
    () => (showNew || showDate) && /* @__PURE__ */ jsxs3(DateInfo, { textAlign: stacked ? "center" : "right", children: [
      showNew && (linkSpace == null ? void 0 : linkSpace.isNew) && /* @__PURE__ */ jsx6(StatusChip, { id: `${idPrefix}app-new-badge-${linkSpace == null ? void 0 : linkSpace.configurationId}`, label: "New!", color: "secondary" }),
      showDate && /* @__PURE__ */ jsx6(
        Typography2,
        {
          id: `${idPrefix}app-date-badge-${linkSpace == null ? void 0 : linkSpace.configurationId}`,
          variant: "caption",
          color: "textSecondary",
          children: getDisplayDate(linkSpace == null ? void 0 : linkSpace.activeDate)
        }
      )
    ] }),
    [linkSpace == null ? void 0 : linkSpace.activeDate, linkSpace == null ? void 0 : linkSpace.isNew, showDate, showNew, stacked, linkSpace == null ? void 0 : linkSpace.configurationId, idPrefix]
  );
  const customBadgeDisplay = useMemo(
    () => customBadgeText && /* @__PURE__ */ jsx6(
      Box2,
      {
        sx: {
          textAlign: stacked ? "center" : "inherit",
          marginRight: variant !== "card" && (showDate || showNew && (linkSpace == null ? void 0 : linkSpace.isNew)) ? 1 : void 0
        },
        children: /* @__PURE__ */ jsx6(
          StatusChip,
          {
            color: customBadgeColor || "info",
            id: `${idPrefix}app-custom-badge-${linkSpace == null ? void 0 : linkSpace.configurationId}-${customBadgeText}`,
            label: customBadgeText
          }
        )
      }
    ),
    [
      customBadgeColor,
      customBadgeText,
      showDate,
      showNew,
      stacked,
      variant,
      linkSpace == null ? void 0 : linkSpace.isNew,
      idPrefix,
      linkSpace == null ? void 0 : linkSpace.configurationId
    ]
  );
  if (isLoading) {
    return /* @__PURE__ */ jsx6(CircularProgress3, __spreadValues({ id: `${idPrefix}app-${linkSpace == null ? void 0 : linkSpace.configurationId}-loading` }, rest));
  }
  const Tag = getContainerTag(tag, variant);
  const BodyTag = getBodyTag(bodyTag, variant);
  const TitleTag = getTitleTag(titleTag, variant);
  const TextTag = getTextTag(textTag, variant);
  const renderChildren = () => {
    if (children) {
      return isFunction(children) ? (() => children(__spreadValues(__spreadValues(__spreadValues({}, linkSpace), analytics), props)))() : cloneElement(children, __spreadValues(__spreadValues({
        role: "link",
        tabIndex: 0,
        style: { cursor: showUrl ? "pointer" : "not-allowed" },
        "aria-label": linkSpace == null ? void 0 : linkSpace.name
      }, analytics), props));
    }
  };
  return /* @__PURE__ */ jsx6(
    SpacesLinkContainer,
    __spreadProps(__spreadValues({
      component: Tag,
      title: linkSpace == null ? void 0 : linkSpace.name,
      className
    }, rest), {
      style: __spreadValues({}, style),
      role: variant === "list" ? "listitem" : role,
      children: /* @__PURE__ */ jsx6(BodyTag, { style: { width: "100%" }, children: /* @__PURE__ */ jsxs3(
        Grid2,
        {
          sx: {
            alignItems: !showDescription || stacked ? "center" : "start",
            flexWrap: "nowrap"
          },
          direction: stacked ? "column" : "row",
          container: true,
          children: [
            !stacked && favoriteIcon,
            FileIcon && (linkSpace == null ? void 0 : linkSpace.url) && ((_b2 = linkSpace == null ? void 0 : linkSpace.type) == null ? void 0 : _b2.toUpperCase()) === "FILE" ? /* @__PURE__ */ jsx6(
              IconLink,
              {
                target: "_blank",
                href: linkSpace == null ? void 0 : linkSpace.url,
                role: "link",
                "aria-labelledby": `${idPrefix}app-title-${linkSpace == null ? void 0 : linkSpace.configurationId}`,
                children: /* @__PURE__ */ jsx6(FileIcon, { "data-testid": "icon" })
              }
            ) : null,
            children ? renderChildren() : body && /* @__PURE__ */ jsxs3(Grid2, { id: `${idPrefix}${linkSpace == null ? void 0 : linkSpace.type}-${linkSpace == null ? void 0 : linkSpace.configurationId}`, sx: { flexGrow: 1 }, children: [
              /* @__PURE__ */ jsx6(
                Box2,
                {
                  sx: {
                    marginBottom: !customBadgeDisplay && (!showDescription || !(linkSpace == null ? void 0 : linkSpace.description)) ? 0 : void 0,
                    paddingTop: stacked ? 3 : void 0,
                    textAlign: stacked ? "center" : void 0
                  },
                  children: /* @__PURE__ */ jsx6(
                    TitleTag,
                    __spreadProps(__spreadValues(__spreadValues({
                      id: `${idPrefix}app-title-${linkSpace == null ? void 0 : linkSpace.configurationId}`,
                      className: titleClassName,
                      tabIndex: 0,
                      style: {
                        cursor: showUrl ? "pointer" : "not-allowed"
                      }
                    }, analytics), props), {
                      role: showUrl ? "link" : role,
                      "aria-label": linkSpace == null ? void 0 : linkSpace.name,
                      "aria-describedby": showNew && (linkSpace == null ? void 0 : linkSpace.isNew) ? `${idPrefix}app-new-badge-${linkSpace == null ? void 0 : linkSpace.configurationId}` : void 0,
                      variant: "h5",
                      title: showName ? linkSpace == null ? void 0 : linkSpace.name : void 0,
                      children: showName ? linkSpace == null ? void 0 : linkSpace.name : void 0
                    })
                  )
                }
              ),
              stacked && dateInfo,
              showDescription && (linkSpace == null ? void 0 : linkSpace.description) && /* @__PURE__ */ jsx6(
                TextTag,
                {
                  component: "div",
                  style: {
                    marginTop: ".5rem",
                    textAlign: stacked ? "center" : void 0,
                    overflow: "hidden",
                    whiteSpace: maxDescriptionWidth ? "nowrap" : void 0,
                    width: maxDescriptionWidth,
                    textOverflow: "ellipsis"
                  },
                  id: `${idPrefix}app-description-${linkSpace == null ? void 0 : linkSpace.configurationId}`,
                  children: /* @__PURE__ */ jsx6(ReactMarkdown2, { children: linkSpace == null ? void 0 : linkSpace.description })
                }
              ),
              variant === "card" && customBadgeDisplay
            ] }),
            variant !== "card" && customBadgeDisplay,
            !stacked && dateInfo
          ]
        }
      ) })
    })
  );
};

// src/lib/SpacesAgreement.tsx
import { Typography as Typography3 } from "@availity/mui-typography";
import ReactMarkdown3 from "react-markdown";
import { jsx as jsx7 } from "react/jsx-runtime";
var SpacesAgreement = ({ spaceId, markdown = false, id: elementId }) => {
  const spaces = useSpaces(spaceId);
  if (spaces && spaces.length > 0) {
    const { description: agreement, id } = spaces[0];
    if (agreement) {
      const children = markdown ? /* @__PURE__ */ jsx7(ReactMarkdown3, { children: agreement }) : agreement;
      return /* @__PURE__ */ jsx7(Typography3, { variant: "agreement", id: elementId || `spaces-agreement-${spaceId || id}`, children });
    }
  }
  return null;
};

// src/lib/SpacesDisclaimer.tsx
import { Disclaimer } from "@availity/mui-disclaimer";
import ReactMarkdown4 from "react-markdown";
import { jsx as jsx8 } from "react/jsx-runtime";
var SpacesDisclaimer = (_a) => {
  var _b = _a, {
    accent = true,
    spaceId,
    markdown = false,
    id: elementId
  } = _b, props = __objRest(_b, [
    "accent",
    "spaceId",
    "markdown",
    "id"
  ]);
  const spaces = useSpaces(spaceId);
  if (spaces && spaces.length > 0) {
    const { description: disclaimer, id } = spaces[0];
    if (disclaimer) {
      const children = markdown ? /* @__PURE__ */ jsx8(ReactMarkdown4, { children: disclaimer }) : disclaimer;
      return /* @__PURE__ */ jsx8(
        Disclaimer,
        __spreadValues({
          accent,
          id: elementId || `spaces-disclaimer-${spaceId || id}`,
          description: children
        }, props)
      );
    }
  }
  return null;
};

// src/lib/SpacesGhostText.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var SpacesGhostText = (_a) => {
  var _b = _a, { spaceId, id } = _b, props = __objRest(_b, ["spaceId", "id"]);
  var _a2;
  const spaces = useSpaces(spaceId);
  const space = spaces == null ? void 0 : spaces[0];
  if (space == null ? void 0 : space.isGhosted) {
    return /* @__PURE__ */ jsx9("small", __spreadProps(__spreadValues({ id: id || `app-ghost-text-${spaceId}` }, props), { children: /* @__PURE__ */ jsx9("em", { children: (_a2 = space == null ? void 0 : space.meta) == null ? void 0 : _a2.ghostText }) }));
  }
  return null;
};
export {
  INITIAL_STATE,
  Spaces,
  SpacesAgreement,
  SpacesContext,
  SpacesDisclaimer,
  SpacesGhostText,
  SpacesImage,
  SpacesLink,
  useSpaces,
  useSpacesContext
};
